module.exports = __webpack_public_path__ + "img/ico_order_delivery.f77620f.png";